import { Box, Flex, useColorModeValue } from '@cardboard-ui/react';
import React, { FC, PropsWithChildren } from 'react';
import { CardContent } from './Card';

type CardHighlightIconProps = PropsWithChildren<{
  height?: string;
}>;

export const CardHighlightIcon: FC<CardHighlightIconProps> = ({
  children,
  height,
}) => {
  const backgroundColor = useColorModeValue('gray.300', 'gray.800');
  const textColor = useColorModeValue('white', 'gray.500');

  return (
    <Flex bgColor={backgroundColor} alignItems="center" height={height}>
      <CardContent>
        <Box color={textColor} fontSize={36}>
          {children}
        </Box>
      </CardContent>
    </Flex>
  );
};
